import { createSelector } from 'reselect';
import { AppState } from '../../model';

/* -------------------------------------------------------------------------- */
/*                               Segment Details                              */
/* -------------------------------------------------------------------------- */

/**
 * Get list of all segment details
 */
const getSegments = (state: AppState) => state.segmentDetails;

/**
 * Get details for a segment
 */
export const findSegment = (id: number) =>
  createSelector(
    getSegments,
    segments => segments[id],
  );
